import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VIEWER_HELP_SECTIONS, ViewerHelpSection } from './viewer-help-sections';

// Keep in sync with the `showcase-phone` mixin the page styles use.
const VIEWER_HELP_PHONE_QUERY: string = '(max-width: 767px), (max-height: 500px) and (orientation: landscape)';

/**
 * A static guide to the viewer stand (`/viewer`): navigation, the toolbar and every side panel tab. The app shell
 * scrolls the page in its own container rather than the window, so the table of contents scrolls headings into view
 * itself instead of relying on the router's anchor scrolling.
 */
@Component({
  selector: 'viewer-help',
  templateUrl: './viewer-help.component.html',
  styleUrls: ['./viewer-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewerHelpComponent implements AfterViewInit {
  public readonly sections: readonly ViewerHelpSection[] = VIEWER_HELP_SECTIONS;
  /** The contents start folded on phones, so the first section shows without scrolling past them. */
  public readonly tocOpen: boolean =
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function' ||
    !window.matchMedia(VIEWER_HELP_PHONE_QUERY).matches;

  public constructor(private readonly host: ElementRef<HTMLElement>, private readonly route: ActivatedRoute) {}

  /** A link to a section, such as `/help#tab-settings`, opens the page at that section. */
  public ngAfterViewInit(): void {
    const fragment: string | null = this.route.snapshot.fragment;
    if (fragment !== null) {
      this.scrollToSection(fragment, 'auto');
    }
  }

  public scrollToSection(id: string, behavior: ScrollBehavior = 'smooth'): void {
    const target: HTMLElement | null = this.host.nativeElement.querySelector(`#${CSS.escape(id)}`);
    target?.scrollIntoView({ behavior, block: 'start' });
  }
}
